import styled from '@emotion/styled';
import { TextBlock } from '~/shared/components';

export const StyledEasysizeWrapper = styled(TextBlock)({
    position: 'relative',
    letterSpacing: 0,
    '#easysize_button, .easysize_button__returning, .easysize_button__out_of_stock, .es-recommended, .es-selected': {
        textDecoration: 'none',
        display: 'inline',
        fontSize: 'inherit',
        lineHeight: 'inherit',
        fontWeight: 'inherit',
        color: 'inherit',
        margin: 0,

        '&:before': {
            content: 'none',
        },
    },
});
